import { styled } from "@mui/material";
import BaseToggleButton, { toggleButtonClasses } from "@mui/material/ToggleButton";
import BaseToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export const ModeToggleButtonGroup = styled(BaseToggleButtonGroup)(({ theme }) => ({
  width: "100%",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: 2,
  gap: 2,
}));

export const ModeToggleButton = styled(BaseToggleButton)(({ theme }) => ({
  flex: 1,
  border: 0,
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(0.25, 1),
  textTransform: "none",
  fontSize: theme.typography.size.small,

  [`&.${toggleButtonClasses.root}:hover`]: {
    backgroundColor: theme.palette.action.hover,
  },
  [`&.${toggleButtonClasses.selected}`]: {
    backgroundColor: theme.palette.background.gridRow.active,
    color: theme.palette.primary.main,
    fontWeight: 500,
    "&:hover": {
      backgroundColor: theme.palette.background.gridRow.active,
    },
  },

  [`&.${toggleButtonClasses.root}.MuiToggleButtonGroup-firstButton, &.${toggleButtonClasses.root}.MuiToggleButtonGroup-middleButton`]: {
    borderTopRightRadius: theme.spacing(0.5),
    borderBottomRightRadius: theme.spacing(0.5),
  },
  [`&.${toggleButtonClasses.root}.MuiToggleButtonGroup-lastButton, &.${toggleButtonClasses.root}.MuiToggleButtonGroup-middleButton`]: {
    borderTopLeftRadius: theme.spacing(0.5),
    borderBottomLeftRadius: theme.spacing(0.5),
  },
}));
